<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>

    <div v-show="!loading" v-if="ready" class="content">
      <div class="box">
        <div class="box-body">
          <!-- 
            <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
            </div>
          </div>
          -->
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#details">Details</a>
            </li>
            <!-- <li>
              <a data-toggle="tab" href="#groups">Groups</a>
            </li>-->
          </ul>

          <div class="tab-content content">
            <div id="details" class="tab-pane fade in active">
              <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.firstName)">
                      <label>First Name :</label>
                      <input required v-model="user.firstName" class="form-control" type="text" name="firstName"
                        :maxlength="max" placeholder="First Name" />
                      <field-messages name="firstName" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is required field</div>
                        <div slot="maxlength">First name should be less than 20 characters</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lastName)">
                      <label>Last Name :</label>
                      <input required v-model="user.lastName" class="form-control" type="text" name="lastName"
                        placeholder="Last Name" />
                      <field-messages name="lastName" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)"
                      :custom="{ email: emailValidator }">
                      <label>Email : </label>
                      <input required v-model="user.email" type="email" class="form-control" name="email"
                        placeholder="Email" />
                      <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field"
                      :class="fieldClassName(formstate.investedAmount)">
                      <label>Invested Amount :</label>
                      <input required v-model="user.invested_amount" class="form-control" type="number"
                        name="investedAmount" :maxlength="max" placeholder="Invested Amount" />
                      <field-messages name="investedAmount" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is required field</div>
                        <div slot="maxlength">Invested Amount should be less than 20 characters</div>
                      </field-messages>
                    </validate>
                  </div>
                  <!-- <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.role)">
                      <label>Role:</label>
                      <select required name="role" class="form-control" v-model="user.role">
                        <option v-for="role in roles" :selected="role && user.role && role._id === user.role._id"
                          :value="role" :key="role._id">{{ role.name }}</option>
                      </select>
                      <field-messages name="role" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate> -->

                  <!-- <div class="form-group">
                          <label>Active Status:</label>
                          <input
                            class="form-control"
                            :disabled="true"
                            :placeholder="user.isActive ? 'Activated' : 'Deactivated'"
                          />
                        </div> -->

                  <!-- <div class="form-group">
                          <label>Enabled Status:</label>
                          <input
                            class="form-control"
                            :disabled="true"
                            :placeholder="user.isEnabled ? 'Enabled' : 'Disabled'"
                          />
                        </div> -->
                  <!-- </div> -->
                </div>
                <div class="col-sm-12">
                   <div class="col-sm-6" >
                  <validate auto-label class="form-group required-field">
                    <label for="dateAdded">Start Date</label>
                    <date-picker required id="startDate" v-model="user.startDate" lang="en"
                      name="startDate" width="100%" use-utc="true"
                      format="DD-MM-YYYY"></date-picker>
                    <field-messages name="dateAdded" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        License Expiry Date is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                </div>
                <!-- <div class="col-sm-12" id="invisibleDiv" v-if="this.user1.roleName == 'Super Admin'">
                  <div class="col-sm-6">
                    <validate auto-label class="form-group" :class="fieldClassName(formstate.invisible)">
                      <label>Invisible</label>
                      <select name="invisible" class="form-control" v-model="user.invisible">
                        <option v-bind:value="false" selected>False</option>
                        <option v-bind:value="true">True</option>
                      </select>
                    </validate>
                  </div>
                </div> -->
                <div class="col-sm-12">

                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.password)">
                      <label>Password :</label>
                      <input required v-model="password" class="form-control" type="password" name="password"
                        placeholder="Password" />
                      <span @click="togglePasswordVisibility('password')" class="password-toggle-icon">
                        <i :class="{ 'fa fa-eye': showPassword, 'fa fa-eye-slash': !showPassword }"></i>
                      </span>
                      <field-messages name="password" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">This is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field"
                      :class="fieldClassName(formstate.confirmPassword, passwordValidation)">
                      <label>Confirm Password :</label>
                      <!-- @input="verifyPasswordMatch" -->
                      <input required v-model="confirmPassword" class="form-control" type="password"
                        name="confirmPassword" placeholder="Confirm Password" />
                      <span @click="togglePasswordVisibility('confirmPassword')" class="password-toggle-icon">
                        <i :class="{ 'fa fa-eye': showPassword, 'fa fa-eye-slash': !showPassword }"></i>
                      </span>
                      <field-messages name="confirmPassword" show="$touched || $submitted" class="form-control-feedback">
                        <!-- <div slot="required">This is a required field</div> -->
                      </field-messages>
                      <a v-if="passwordValidation" style="color: red;">Passwords do not match.</a>

                    </validate>
                  </div>
                </div>

              </vue-form>

              <div class="col-sm-12 text-right">
                <router-link :to="{ name: 'Users' }">
                  <button class="mr-2 btn btn-default" type="button">Cancel</button>
                </router-link>
                <button class="btn gradientbt" type="submit" @click="createUser"
                  :disabled="!(formstate.$dirty && formstate.$valid && !passwordValidation)">Add User</button>
              </div>

           
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserGroups from './UserGroups.vue';
import UserPermissions from './UserPermissions.vue';
// import { USER_ROLES } from '../../../config';
import {
  userService,
  authService,
  formService,
  eventBus,
} from '../../../services';
import {
  EVENTS,
  USER_ROLES
} from '../../../config';
import {
  mapState
} from 'vuex';

export default {
  name: 'UserCreate',
  components: {
    UserGroups,
    UserPermissions,
  },
  data() {
    return {
      ready: false,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      USER_ROLES: USER_ROLES,
      max: 20,
      user: {
        // invisible: false,
        invested_amount: '',
      },
      password: '',
      confirmPassword: '',
      showPassword: false,
      roles: [],
      permissions: [],
      formstate: {},
      passwordValidtion: false,
    };
  },
  computed: {
    passwordValidation() {
      return this.password !== this.confirmPassword;
    },
    computedUserScope() {
      return userService.computeUserScope(this.user);
    },
    ...mapState({
      user1: state => state.auth.user,

    }),
  },
  methods: {
    emailValidator: formService.emailValidator,
    fieldClassName: formService.fieldClassName,

    togglePasswordVisibility(field) {
      this.showPassword = !this.showPassword;
      const inputField = document.querySelector(`input[name=${field}]`);
      if (inputField) {
        inputField.type = this.showPassword ? 'text' : 'password';
      }
    },
    // verifyPasswordMatch() {
    //   if (this.user.password !== this.user.confirmPassword) {
    //     this.passwordValidtion = true
    //   } else {
    //     this.passwordValidtion = false;
    //   }
    // },

    getRoles() {
      return this.$roleRepository
        .list({
          $embed: ['permissions']
        })
        .then(response => {
          console.log('user role response', response);
          let updateRoles = response.data.docs.filter(item => (item.name === 'Admin' || item.name === 'Journey Manager' || item.name === 'GA Head' || item.name === 'JMA User'));
          this.roles = updateRoles;
        })
        .catch(error => {
          console.error('UserCreate.getRoles-error:', error);
          this.$snotify.error('Get roles failed', 'Error!');
        });
    },
    createUser() {

      this.loading = true;
      this.user['password'] = this.confirmPassword;
      let role = {
        // _id: this.user1.role,
        name: 'Admin',
        rank: 2,

      }
      this.user['withdrawl_amount'] = 0;

      this.user['role'] = role;
      console.log('createUser', this.user)
      return authService
        .inviteUser(this.user)
        .then(response => {
          console.log('User Successfully Created!');
          this.loading = false;
          this.$snotify.success('User created', 'Success!');
          this.disabled = true;
          this.$router.push('/users');
        })
        .catch(error => {
          this.loading = false;
          console.error('UserCreate.createUser-error:', error);
          // this.$router.push('/users');
          if (error.statusText == "Conflict") {
            this.$snotify.error('Email already in use!!', 'Error!');
          } else if (error.statusText == "Internal Server Error") {
            this.$snotify.success('User is created', 'Success!')
          } else {
            this.$snotify.error('Create user failed', 'Error!');
          }
        });
    },
    updateGroups(groups) {
      this.user.groups = groups;
    },
    updatePermissions(permissions) {
      this.user.permissions = permissions;
    },
  },
  created() {
    const promises = [];
    this.loading = true;
    promises.push(this.getRoles());
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
        this.user = {
          isActive: false,
          isEnabled: true,
          role: this.roles.find(role => {
            return role.name === USER_ROLES.USER;
          }),
          groups: [],
          permissions: [],
        };
        /* if (!this.user.role) {
          this.flash = true;
          this.flashType = 'error';
          this.flashMessage =
            'User role not found, please make sure the role values in the client and ' +
            'server configs are the same.';
          this.user.role = { permissions: [] };
        } */
      })
      .catch(() => {
        this.loading = false;
      });
    eventBus.$on(EVENTS.USER_GROUPS_UPDATED, this.updateGroups);
    eventBus.$on(EVENTS.USER_PERMISSIONS_UPDATED, this.updatePermissions);
  },
  beforeDestroy() {
    eventBus.$off(EVENTS.USER_GROUPS_UPDATED, this.updateGroups);
    eventBus.$off(EVENTS.USER_PERMISSIONS_UPDATED, this.updatePermissions);
  },
};
</script>

<style scoped>
.required-field>label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red
}

.gradientbt {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.password-toggle-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// UserCreate.vue?c16aca50